var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usuarios"},[(_vm.usuario)?_c('usuarios-form',{attrs:{"usuarioProp":_vm.usuario}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }